export function init_custom_tabs($ = window.jQuery) {

	if (!$ || typeof $.fn === 'undefined') {
		console.warn('jQuery not loaded for tabs');
		return;
	}

	function content_tabs() {
		const $container = $('.tabs-content-container');
		if (!$container.length) return;

		const $tabTitles = $container.find('.tabs-title, .tabs-title-mobile');
		const $tabPanes = $container.find('.tab-pane');

		// Hide all tab panes except the first one
		$tabPanes.not('.active').hide();

		// Adjust height desktop 
		if (window.innerWidth > 767) {
			adjust_container_height();
		}

		$tabTitles.on('click', function (e) {
			e.preventDefault();

			const $clicked = $(this);
			const target = $clicked.attr('data-target-content');

			// Skip if already active
			if ($clicked.hasClass('active')) return;

			$tabTitles.removeClass('active');
			$clicked.addClass('active');

			const $targetPane = $tabPanes.filter('[data-inner-content="' + target + '"]');

			$tabPanes.removeClass('active').fadeOut(200, function () {
				$targetPane.fadeIn(200, function () {
					$targetPane.addClass('active');

					// Adjust height desktop
					if (window.innerWidth > 767) {
						adjust_container_height();
					}
				});
			});
		});

		function adjust_container_height() {
			const $activePane = $container.find('.tab-pane.active');
			if ($activePane.length) {
				const newHeight = $activePane.outerHeight(true);
				$container.height(newHeight);
			}
		}
	}

	content_tabs();
}
